import React from 'react';
import cn from 'classnames';
import { Text, TEXT_VARIANTS } from 'ui/Typography';
import InfoTooltip from 'components/shared/InfoTooltip';
import IncompleteAssessmentSection from 'components/VideoResponse/Grading/Modal/AutomatedAnalysis/IncompleteAssessmentSection.jsx';
import ConfidenceIcons from 'components/VideoResponse/Grading/Modal/AutomatedAnalysis/ConfidenceIcons.jsx';
import { BetaLabel } from 'components/BetaProgram';
import Indicator from './Indicator';

const RangeGauge = ({
  ranges,
  value,
  overallEndThreshold,
  componentIndex,
  featureName,
  tooltipText,
  qualitativeValue,
  quantitativeValue,
  rangesCanBeRendered,
  status,
  error,
  invalidValue,
  hasIcon,
  betaFeature,
}) => {
  const between = (x, min, max) => {
    return x >= min && x <= max;
  };

  const createRanges = () => {
    return ranges.map((range, index) => {
      const subtractedRange = range.endingThreshold - range.startingThreshold;
      const subtractedValue = value - range.startingThreshold;

      if (between(value, range.startingThreshold, range.endingThreshold)) {
        return (
          <React.Fragment key={range.startingThreshold}>
            <div
              className={`Range Range-rangeWithIndicator Range-${range.type} w-${range.width}p op-1`}
            >
              <Indicator
                indicatorPlacement={
                  Math.floor((subtractedValue * 100) / subtractedRange) === 100
                    ? 90
                    : Math.floor((subtractedValue * 100) / subtractedRange)
                }
                componentIndex={componentIndex}
              />
            </div>
          </React.Fragment>
        );
      }
      if (value > overallEndThreshold && ranges.length - 1 === index) {
        return (
          <React.Fragment key={range.startingThreshold}>
            <div
              className={`Range Range-rangeWithIndicator Range-${range.type} w-${range.width}p op-1`}
            >
              {ranges.length - 1 === index && (
                <Indicator
                  indicatorPlacement={100}
                  componentIndex={componentIndex}
                />
              )}
            </div>
          </React.Fragment>
        );
      }
      if (!value && value !== 0) {
        return (
          <React.Fragment key={range.startingThreshold}>
            <div
              className={`Range Range-rangeWithIndicator Range-${range.type} w-${range.width}p op-1`}
            >
              {index === 0 && (
                <Indicator
                  indicatorPlacement={0}
                  componentIndex={componentIndex}
                />
              )}
            </div>
          </React.Fragment>
        );
      }
      return (
        <div
          key={range.startingThreshold}
          className={`Range Range-${range.type} w-${range.width}p`}
        />
      );
    });
  };

  return (
    <div className="ModuleContainer w-100p h-164 p-16 bdrs-small border-solid border border-gray-light">
      <div className="mb-16">
        <Text variant={TEXT_VARIANTS.INSTRUX_SEMIBOLD} className="mb-16 mt-32">
          {featureName}
        </Text>
        <InfoTooltip
          className="c-gray-light ml-8"
          tooltip={tooltipText}
          placement="right"
        />
        {betaFeature && <BetaLabel className="ml-8" whiteOnBlack />}
      </div>
      <div className={cn('mx-a', { 'mw-200': status === 'complete' })}>
        <div className="d-f ai-c fd-c mb-20">
          {hasIcon ? (
            <div className="mb-6">
              <ConfidenceIcons confidenceScore={quantitativeValue} />
            </div>
          ) : (
            <Text className="mb-2" variant={TEXT_VARIANTS.TITLE}>
              {quantitativeValue}
            </Text>
          )}

          <Text variant={TEXT_VARIANTS.INSTRUX_SMALL_SEMIBOLD}>
            {qualitativeValue}
          </Text>
        </div>
        {rangesCanBeRendered ? (
          <div className="Range-Container">{createRanges()}</div>
        ) : (
          <IncompleteAssessmentSection
            status={status}
            error={error}
            processText={featureName}
            invalidValue={invalidValue}
          />
        )}
      </div>
    </div>
  );
};

export default RangeGauge;
